import React from 'react';
import { makeStyles, type Theme, createStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Fields from './fields';
import API from './api';
import * as helper from '../../helper/index';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    backButton: {
      marginRight: theme.spacing(1),
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    close: {
      padding: theme.spacing(0.5),
    },
  }),
);

export default function HorizontalLabelPositionBelowStepper(props: any) {
  const history = useHistory();
  const classes = useStyles();
  const steps: Record<string, any> = props.createComponentSchema;

  const [activeStep, setActiveStep] = React.useState(0);
  const handleNext = () => {
    setActiveStep((prevActiveStep) => {
      return prevActiveStep < steps.length && prevActiveStep < steps.length - 1 ? prevActiveStep + 1 : prevActiveStep;
    });
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  function handleTabStateChange(value: any = {}) {
    props.updateForm({ ...props.inheritState, ...value });
  }

  async function update() {
    await API.update(props.url, props?.inheritState?.id, props.inheritState)
      .then((res) => {
        props.updateForm(res);
        handleNext();
        history.push(props.return);
      })
      .catch((e) => {
        helper.axiosErrorHandling(e);
      })
      .finally(() => {});
  }

  async function save() {
    await API.create(props.url, props.inheritState)
      .then((res) => {
        props.updateForm(res);
        handleNext();
        history.push(props.return);
      })
      .catch((e) => {
        helper.axiosErrorHandling(e);
      })
      .finally(() => {});
  }

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((step: Record<string, any>) => (
          <Step key={step.tabName}>
            <StepLabel>{step.tabName}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
        <div>
          <Typography component={'span'} className={classes.instructions}>
            <Fields
              editFields={steps[activeStep]?.editFields}
              onFieldStateUpdate={handleTabStateChange}
              inheritState={props.inheritState}
            />
          </Typography>
          <div>
            <Button disabled={activeStep === 0} onClick={handleBack} className={classes.backButton}>
              Back
            </Button>
            {(() => {
              if (!props?.inheritState?.id && activeStep === steps.length - 1) {
                return (
                  <Button variant="contained" color="primary" onClick={save}>
                    Save & Finish
                  </Button>
                );
              }
            })()}
            {(() => {
              if (props?.inheritState?.id) {
                return (
                  <Button variant="contained" color="primary" onClick={update}>
                    update
                  </Button>
                );
              }
              if (!props?.inheritState?.id && activeStep !== steps.length - 1) {
                return (
                  <Button variant="contained" color="primary" onClick={save}>
                    Save
                  </Button>
                );
              }
            })()}
          </div>
        </div>
      </div>
    </div>
  );
}
